import React from 'react';
import { useCommunitySettings } from '@guuru/community-web';
import { usePageTitle } from '@guuru/react-hooks';
import ExpertsList from '../../components/Experts/ExpertsList';

const AllExperts = function () {
  const { partnerName } = useCommunitySettings();
  usePageTitle(
    `${partnerName} Community Members | GUURU`,
    `Meet experienced members of the ${partnerName} community sharing product advice and real customer experience.`,
  );
  return <ExpertsList />;
};

export default AllExperts;
